// URL d'annonce -> operador. Une entrée = une page marque servie à cette URL exacte
// (comparaison insensible à la casse). Pas de logo de marque : seulement le nom, en texte.
// primary = couleur des boutons d'appel (tableau « Couleur Primaire (CTA) »), secondary = couleur d'accent.
// site = site officiel de la marque, cité dans l'encadré « Mis Gestiones Luz no es [marca] ».
//        Laisser vide si l'adresse n'est pas vérifiée : l'encadré renvoie alors vers la facture.
// phone = numéro propre à la page (clé de PHONE_CONFIG.ES.fibra), sinon numéros LP / SB par défaut.

export const PROVIDERS = {
  "/comparar-digi": { name: "Digi", site: "digimobil.es", primary: "#00AEEF" },
  "/comparar-movistar": { name: "Movistar", site: "movistar.es", primary: "#019DF4" },
  "/comparar-o2": { name: "O2", site: "o2online.es", primary: "#04256C" },
  "/comparar-simyo": { name: "Simyo", site: "simyo.es", primary: "#FF6C01" },
  "/comparar-vodafone": { name: "Vodafone", site: "vodafone.es", primary: "#E60000" },
  "/lowi-comparator": { name: "Lowi", site: "lowi.es", primary: "#000000", secondary: "#E82847", phone: "LOWI" },
};

// Anciennes URL d'annonces qui affichent la page d'accueil (aucune sur ce site).
export const HOME_ALIASES = [];
